// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatFlashController from "./chat_flash_controller"
application.register("chat-flash", ChatFlashController)

import DocUploadController from "./doc_upload_controller"
application.register("doc-upload", DocUploadController)

import RedirectController from "./redirect_controller"
application.register("redirect", RedirectController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import OfferSizingController from "./offer_sizing_controller"
application.register("offer-sizing", OfferSizingController)

import BalanceTrendController from "./balance_trend_controller"
application.register("balance-trend", BalanceTrendController)

import PdfViewerController from "./pdf_viewer_controller"
application.register("pdf-viewer", PdfViewerController)
